module.exports = __webpack_public_path__ + "static/media/background_2.d47f3ccf.png";